export const NAICSCodes = [
  { value: '111', label: '111 (Crop Production)' },
  { value: '4242', label: '4242 (Individuals)' },
  { value: '4245', label: '4245 (Farm Product Raw Material Merchant Wholesalers)' },
  { value: '453', label: '453 (Miscellaneous Store Retailers)' },
  { value: '4541', label: '4541 (Non-Storefront Retailers)' },
  { value: '484', label: '484 (Transporters/Distributors)' },
  { value: '4922', label: '4922 (Local messengers and local delivery)' },
  { value: '5413', label: '5413 (Architectural, Engineering, and Related Services)' },
  { value: '562', label: '562 (Waste Management and Remediation Services)' }
]
